export default __webpack_public_path__ + "static/media/cake_greentea.a7441c35.jpg";